import { useSelector } from "react-redux"

/**
 * Whether the logged-in user may export data (Excel/CSV/XLSX).
 * Controlled by the user-level "Allow Exports" flag from auth.
 */
const useAllowExports = () => {
  const authUser = useSelector(state => state.Login?.authUser)
  return authUser?.allowExports === true
}

export default useAllowExports
